// src/components/Control/Operator/ControlBar.tsx
// Desktop: свёрнутая строка управления над картой; раскрывается в панель
// с кнопками/джойстиком, скоростью и STOP. Клавиатура работает и в свёрнутом виде.
import React from 'react';
import { useDriveState, useRobot, useUi, useUiActions, LayoutPreset } from '../robot/RobotContext';
import ControlPad from './ControlPad';
import { Icon, Segmented } from './ui';

const ControlBar: React.FC<{ showLayout: boolean }> = ({ showLayout }) => {
  const { drive } = useRobot();
  const open = useUi(u => u.controlOpen);
  const layout = useUi(u => u.layout);
  const flash = useUi(u => u.flash);
  const { toggleControl, setLayout } = useUiActions();
  const speed = useDriveState(d => d.speed);
  const keyboard = useDriveState(d => d.keyboard);
  const moving = useDriveState(d => d.moving);

  return (
    <div className="op-controlbar">
      <button type="button" className={`op-ctl-toggle ${open ? 'on' : ''}`} aria-expanded={open} aria-controls="op-ctl-panel"
              onClick={() => toggleControl()}>
        <Icon name="gamepad" size={18} /> Управление <Icon name={open ? 'chevronUp' : 'chevronDown'} size={16} />
      </button>
      <span className="op-sep" aria-hidden="true" />
      <span className={`op-ctl-hint ${keyboard ? '' : 'off'}`} title={keyboard ? 'Клавиатура включена' : 'Клавиатура выключена'}>
        {keyboard ? 'WASD / ↑↓←→' : 'Клавиатура выкл.'}
      </span>
      <span className="op-sep" aria-hidden="true" />
      <span className="op-ctl-speed">
        Скорость
        <button type="button" className="op-mini" aria-label="Медленнее" onClick={() => drive.setSpeed(speed - 0.05)}>−</button>
        <b>{speed.toFixed(2)} м/с</b>
        <button type="button" className="op-mini" aria-label="Быстрее" onClick={() => drive.setSpeed(speed + 0.05)}>+</button>
      </span>
      {moving && <span className="op-moving" role="status">● едет</span>}
      {flash && <span className="op-flash" role="status">{flash.text}</span>}
      <span className="op-spacer" />
      {showLayout && (
        <Segmented<LayoutPreset> label="Раскладка карты и камеры" value={layout} onChange={setLayout}
                   options={[['map', 'Карта'], ['split', 'Поровну'], ['camera', 'Камера']]} />
      )}
      {open && (
        <div id="op-ctl-panel" className="op-ctl-panel" role="region" aria-label="Управление роботом">
          <button type="button" className="op-icon-btn op-ctl-close" aria-label="Свернуть управление" onClick={() => toggleControl(false)}>
            <Icon name="close" size={18} />
          </button>
          <ControlPad variant="desktop" />
        </div>
      )}
    </div>
  );
};

export default ControlBar;
